import axios from 'axios';
import {
  AI_PROMPT_BUILDER_GENERATE_IMAGE_LAYOUTS_BEGIN,
  AI_PROMPT_BUILDER_GENERATE_IMAGE_LAYOUTS_SUCCESS,
  AI_PROMPT_BUILDER_GENERATE_IMAGE_LAYOUTS_FAILURE,
  AI_PROMPT_BUILDER_GENERATE_IMAGE_LAYOUTS_DISMISS_ERROR,
} from './constants';
import { builderSurfaceMultiPartHeader } from '../../../common/utils/restApiHeaderUtils';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function generateImageLayouts(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: AI_PROMPT_BUILDER_GENERATE_IMAGE_LAYOUTS_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const projectId = args.get('projectId');
      const version = args.get('projectVersion');
      const header = builderSurfaceMultiPartHeader(projectId);
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/layout/image-to-layouts`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: AI_PROMPT_BUILDER_GENERATE_IMAGE_LAYOUTS_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: AI_PROMPT_BUILDER_GENERATE_IMAGE_LAYOUTS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGenerateImageLayoutsError() {
  return {
    type: AI_PROMPT_BUILDER_GENERATE_IMAGE_LAYOUTS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case AI_PROMPT_BUILDER_GENERATE_IMAGE_LAYOUTS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        generateImageLayoutsPending: true,
        generateImageLayoutsError: null,
      };

    case AI_PROMPT_BUILDER_GENERATE_IMAGE_LAYOUTS_SUCCESS:
      // The request is success
      return {
        ...state,
        generateImageLayoutsPending: false,
        generateImageLayoutsError: null,
      };

    case AI_PROMPT_BUILDER_GENERATE_IMAGE_LAYOUTS_FAILURE:
      // The request is failed
      return {
        ...state,
        generateImageLayoutsPending: false,
        generateImageLayoutsError: action.data.error,
      };

    case AI_PROMPT_BUILDER_GENERATE_IMAGE_LAYOUTS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        generateImageLayoutsError: null,
      };

    default:
      return state;
  }
}
